import './RangeSlider.scss';

const RangeSlider = (props) => {
    return (
        <div className='v2__range-slider-holder'>
            <div className="fill" style={{ width: `${(((props?.value - props?.min) ?? 0) / ((props?.max - props?.min) ?? 100)) * 100}%` }}></div>
            <input
                type="range"
                className="v2__range-slider"
                min={props.min ?? 0}
                max={props.max ?? 100}
                value={props.value ?? 0}
                onChange={props.onChange ?? ((e) => {console.log('v2 Slider onChange: ', e)})}
            />
        </div>
    );
};

export default RangeSlider;
